/**
 * SyncedFromGrabOverlay Component
 *
 * Overlay displayed on a tenant portal when metadata editing is disabled
 * for variables synced from Grab. Wraps the experiment Overlay component.
 */
import React from 'react';

import { METADATA_LOCK_MESSAGES } from '../constants/messages';
import Overlay from '@/features/experiment/components/overlay';

interface SyncedFromGrabOverlayProps {
  show: boolean;
}

export const SyncedFromGrabOverlay = ({ show }: SyncedFromGrabOverlayProps) => {
  return (
    <Overlay
      title={METADATA_LOCK_MESSAGES.title}
      subTitle={METADATA_LOCK_MESSAGES.description}
      showOverlay={show}
    />
  );
};
